import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    callout:
      'Don’t worry, payments received to your old IBAN are automatically transferred to the new one for 3 months',
    cardDescription:
      'Shine becomes a payment institution: we are going to improve your pro account experience and offer you some new services.',
    cardTitle: 'Discover your new Shine account',
    cta: 'Read our terms and conditions',
    ctaWithMissingInformation: 'Add your information',
    listTitle: 'What is the impact for you today?',
    missingInformation:
      'We will now ask you for some **additional information**',
    newCgu: '**Consult and access our new terms and conditions**',
    newIban: 'Access your **new IBAN** now',
  },
  fr: {
    callout:
      'Pas d’inquiétude, les virements reçus sur votre ancien IBAN sont automatiquement transférés vers le nouveau pendant 3 mois',
    cardDescription:
      'Shine devient établissement de paiement : nous allons pouvoir améliorer l’expérience de votre compte pro et vous proposer de nouveaux services.',
    cardTitle: 'Découvrez votre nouveau compte Shine',
    cta: 'Lire nos CGU',
    ctaWithMissingInformation: 'Compléter vos informations',
    listTitle: 'Quel impact pour vous aujourd’hui ?',
    missingInformation:
      'Nous allons vous demander quelques **informations complémentaires**',
    newCgu: '**Consultez et acceptez nos nouvelles CGU**',
    newIban: 'Accédez à votre **nouvel IBAN** dès maintenant',
  },
});

export default locales;
